import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputTextSF from "../../../widgets/form/InputTextSF";

const ProductItemModalUI = ({
	context, successMsg, errorList, setErrorList,
	createMode, onSubmit, submitted, onCancelCreate,
	priceF, onPriceFChange, priceFError, setPriceFError,
	maker, onMakerChange, makerError, setMakerError,
	itemName, onItemNameChange, itemNameError, setItemNameError,
	description, onDescriptionChange, descriptionError, setDescriptionError,

}) =>
	<ModalFormUI
		context={context}
		titleLabel='Create Product Item'
		buttonLabel='Create Item'
		cancelLabel='Cancel'
		isOpen={createMode}
		onRequestClose={onCancelCreate}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>
		<div className='g_flex_h g_flex_top'>
			<div className='col'>
				<InputTextSF type='text' name='maker' maxLength={40}
					label='Maker'
					value={maker} onChange={onMakerChange}
					error={makerError} setError={setMakerError}
				/>
				<InputTextSF type='text' name='price' maxLength={40}
					label='Price'
					value={priceF} onChange={onPriceFChange}
					error={priceFError} setError={setPriceFError}
				/>
			</div>
			<div>
				<InputTextSF type='text' name='item_name' maxLength={250}
					label='Item name'
					value={itemName} onChange={onItemNameChange}
					error={itemNameError} setError={setItemNameError}
				/>

				<InputTextSF type='text' name='description' maxLength={250}
					label='Description'
					value={description} onChange={onDescriptionChange}
					error={descriptionError} setError={setDescriptionError}
				/>
			</div>
		</div>
	</ModalFormUI>

export default ProductItemModalUI;
